import { createElement } from 'react';

import { Label } from 'components';
import { useCatalogTranslation } from 'hooks';
import { dateTimeFormat, numberFormat } from 'utils/formater';
import { pickValue } from 'utils/objects';

function useTable(config) {
  const catalogTranslation = useCatalogTranslation();

  const getRows = function (headers, data = [], extras) {
    const rows = Array.isArray(data) ? data : [];

    return rows.map((row, index) => ({
      data: row,
      id: pickValue(row, config?.id || 'id') ?? index,
      values: headers.map((header) => {
        const align = header?.align || 'center';
        let label = pickValue(row, header.name);

        switch (header.type) {
          default: { break; }

          case 'datetime': {
            label = dateTimeFormat(label, undefined, true);
            break;
          }

          case 'number': {
            let format = undefined;
            if (header?.format === 'percentage') {
              format = '0,0.00 %';
            }

            label = numberFormat(label, undefined, format);
            break;
          }
        }

        if (typeof header.render === 'function') {
          label = header.render(label, row, extras);
        }

        if (header.catalog && typeof label === 'string') {
          label = catalogTranslation(label, ...header.catalog.split('.'));
        }

        switch (header.component) {
          default: { break; }

          case 'label': {
            label = createElement(Label, {
              color: header?.color
                ? header?.color[pickValue(row, header.name)]
                : 'default',
              children: label,
            });
            break;
          }
        }

        return {
          align,
          label,
        };
      }),
    }));
  };

  const generateTable = function (headers, data = [], extras = {}) {

    const getHeaderLabel = function (header) {
      if (header.label) {
        return header.label;
      } else if (header.name) {
        return typeof config?.translate === 'function'
          ? config?.translate('table.headers.'.concat(header.name))
          : header.name;
      } else {
        return '';
      }
    };

    const filteredHeaders = (Array.isArray(headers)
      ? headers.filter((header) => !header?.hidden)
      : []);

    return {
      headers: filteredHeaders.map(getHeaderLabel),
      rows: getRows(filteredHeaders, data, extras),
    };
  };

  return {
    getRows,
    generateTable,
  };
}

export default useTable;
